"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanMatcherContext = void 0;
var constants_1 = require("../../logger/constants");
function booleanMatcherContext(log, ruleAttr) {
    return function booleanMatcher(runtimeAttr) {
        var booleanMatches = ruleAttr === runtimeAttr;
        log.debug(constants_1.ENGINE_MATCHER_BOOLEAN, [ruleAttr, runtimeAttr]);
        return booleanMatches;
    };
}
exports.booleanMatcherContext = booleanMatcherContext;
